import React, { useEffect, useState } from 'react';

interface InFeedAdProps {
  className?: string;
}

export const InFeedAd: React.FC<InFeedAdProps> = ({ className = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Defer AdSense loading for better performance
    const loadAdSense = () => {
      if (!window.adsbygoogle) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9957943271015513';
        script.crossOrigin = 'anonymous';
        script.async = true;
        script.onload = () => setIsLoaded(true);
        document.head.appendChild(script);
      } else {
        setIsLoaded(true);
      }

      if (window.adsbygoogle && isLoaded) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadAdSense);
    } else {
      setTimeout(loadAdSense, 200);
    }
  }, [isLoaded]);

  return (
    <div className={`my-8 ${className}`}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="fluid"
        data-ad-layout-key="-gi-15-2l-9p+w0"
        data-ad-client="ca-pub-9957943271015513"
        data-ad-slot="8285178880"
      />
    </div>
  );
}; 